module.exports = __webpack_public_path__ + "static/media/check.d44c81d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/check.svg
// module id = 1518
// module chunks = 0